module.exports = __webpack_public_path__ + "img/work_from_office.e5288a47.svg";